import _styled from "styled-components";
var _excluded = ["children", "icon", "iconHeight", "iconWidth", "variant"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import { TextButton } from "../Button/TextButton/TextButton";
import { ICON_BUTTON__BUTTON_CLASS, ICON_BUTTON__ICON_CLASS } from "./constants/classNames";
import * as styles from "./styles";
export var TextIcon = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    icon = _ref.icon,
    iconHeight = _ref.iconHeight,
    iconWidth = _ref.iconWidth,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'trailing' : _ref$variant,
    buttonProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledTextButton, _extends({
    className: ICON_BUTTON__BUTTON_CLASS,
    "data-variant": variant,
    ref: forwardedRef
  }, buttonProps, {
    $_css: styles.iconButton
  }), children, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: ICON_BUTTON__ICON_CLASS,
    height: iconHeight,
    src: icon,
    width: iconWidth
  }));
});
var _StyledTextButton = /*#__PURE__*/_styled(TextButton).withConfig({
  displayName: "TextIcon___StyledTextButton",
  componentId: "sc-9b43gn-0"
})(["", ""], function (p) {
  return p.$_css;
});